const ADMINS = ["group_admin", "entity_admin", "subenterprise_manager"];
const WAREHOUSE = [...ADMINS, "warehouse_keeper"];
const CHEF = [...ADMINS, "chef_chantier"];
/**
 * Shortage / need state machine (PRD M07-03). Shared by the API (enforcement) and the apps (which actions to
 * show). worker → chef de chantier → administrator / purchasing → warehouse → site.
 *
 *  reported ─┬─► validated_by_chef ─► sent_to_purchasing ─┬─► in_stock ─────┐
 *            │                                             ├─► ordered ─► in_stock ─► delivered_to_site ─► closed
 *            │                                             ├─► deferred ─► sent_to_purchasing
 *            └─► rejected                                  └─► rejected
 */
export const NEED_TRANSITIONS = [
    { from: "reported", to: "validated_by_chef", roles: CHEF },
    { from: "reported", to: "rejected", roles: CHEF, requiresComment: true },
    { from: "validated_by_chef", to: "sent_to_purchasing", roles: [...CHEF, "warehouse_keeper"] },
    { from: "validated_by_chef", to: "in_stock", roles: WAREHOUSE },
    { from: "validated_by_chef", to: "ordered", roles: WAREHOUSE },
    { from: "validated_by_chef", to: "deferred", roles: ADMINS, requiresComment: true },
    { from: "validated_by_chef", to: "rejected", roles: CHEF, requiresComment: true },
    { from: "sent_to_purchasing", to: "in_stock", roles: WAREHOUSE },
    { from: "sent_to_purchasing", to: "ordered", roles: WAREHOUSE },
    { from: "sent_to_purchasing", to: "deferred", roles: ADMINS, requiresComment: true },
    { from: "sent_to_purchasing", to: "rejected", roles: ADMINS, requiresComment: true },
    { from: "deferred", to: "sent_to_purchasing", roles: ADMINS },
    { from: "deferred", to: "in_stock", roles: WAREHOUSE },
    { from: "deferred", to: "ordered", roles: WAREHOUSE },
    { from: "deferred", to: "rejected", roles: ADMINS, requiresComment: true },
    { from: "ordered", to: "in_stock", roles: WAREHOUSE },
    { from: "ordered", to: "delivered_to_site", roles: WAREHOUSE },
    { from: "in_stock", to: "delivered_to_site", roles: [...WAREHOUSE, "chef_chantier"] },
    { from: "delivered_to_site", to: "closed", roles: CHEF },
];
export const NEED_OPEN_STATES = ["reported", "validated_by_chef", "sent_to_purchasing", "in_stock", "ordered", "deferred"];
export function findTransition(from, to) {
    return NEED_TRANSITIONS.find((t) => t.from === from && t.to === to);
}
export function allowedTransitions(from, roles) {
    const isGroupAdmin = roles.includes("group_admin");
    return NEED_TRANSITIONS.filter((t) => t.from === from && (isGroupAdmin || t.roles.some((r) => roles.includes(r))));
}
//# sourceMappingURL=need-workflow.js.map